import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from '@angular/common/http';
import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable, throwError, of } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  constructor(
    private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  getDashboardData(): Observable<any> {
    return this.http.get(`${environment.api_URL}/dashboard`).pipe(
        retry(1), // Retry once on failure
        catchError((error: HttpErrorResponse) => {
          return throwError(() => ({
            status: false,
            message: this.getErrorMessage(error),
            error: error
          }));
        })
    );
  }
  getStats(): Observable<any> {
    return this.http.get(`${environment.api_URL}/stats/dashboard`).pipe(
        retry(1), // Retry once on failure
        catchError((error: HttpErrorResponse) => {
          return throwError(() => ({
            status: false,
            message: this.getErrorMessage(error),
            error: error
          }));
        })
    );
  }
  createToken(payload:any): Observable<any> {
    return this.http.post(`${environment.api_URL}/dashboard/generate`,payload).pipe(
        retry(1),
        catchError((error: HttpErrorResponse) => {
          return throwError(() => ({
            status: false,
            message: this.getErrorMessage(error),
            error: error
          }));
        })
    );
  }

  private getErrorMessage(error: HttpErrorResponse): string {
    if (error.status === 0) {
      return 'Network error. Please check your connection.';
    } else if (error.status === 401) {
      return 'Invalid credentials.';
    } else if (error.status === 403) {
      return 'Access denied.';
    } else if (error.status >= 500) {
      return 'Server error. Please try again later.';
    } else {
      return 'Login failed. Please try again.';
    }
  }
}
